/* CEN: Bundle builder - tier table parsed from data-tiers (mirrors the Shopify discount function exactly). */
(function(){
var root=document.querySelector('[data-cen-bundle]');if(!root)return;
var checks=[].slice.call(root.querySelectorAll('.cen-bundle__check'));
var countEl=root.querySelector('.cen-bundle__count');
var priceEl=root.querySelector('.cen-bundle__lines .price');
var addBtn=root.querySelector('.cen-bundle__add');
var brand=root.dataset.brand||'This product';
var mpn=root.dataset.mpn||'';
var label=(brand+' '+mpn).trim();
var vmap={};try{vmap=JSON.parse(root.querySelector('[data-cen-bundle-variants]').textContent)}catch(e){}
var tiers=[];
try{tiers=(root.dataset.tiers||'').split(',').map(function(t){t=t.trim();if(t.slice(-1)==='%')return {pct:parseFloat(t)/100};return {fix:Math.round(parseFloat(t.replace(/[^0-9.]/g,''))*100)}}).filter(function(t){return (t.pct&&!isNaN(t.pct))||(t.fix&&!isNaN(t.fix))})}catch(e){}
if(!tiers.length)tiers=[{fix:500},{fix:1000},{pct:0.05},{pct:0.075},{pct:0.10}];
function money(p){return '\u00a3'+(p/100).toFixed(2)}
function mainVid(){var f=document.querySelector('form[action*="/cart/add"] [name="id"]');return f?f.value:null}
function mainPrice(){var vid=mainVid();if(vid&&vmap[vid]!=null)return vmap[vid];var k=Object.keys(vmap);return k.length?vmap[k[0]]:0}
function selected(){return checks.filter(function(c){return c.checked})}
function tierDiscount(n,total){if(n<=0)return 0;var t=tiers[Math.min(n,tiers.length)-1];return t.pct?Math.round(total*t.pct):t.fix}
var selAll=root.querySelector('.cen-bundle__all');
function syncAll(){if(!selAll)return;var avail=checks.filter(function(c){return !c.disabled});selAll.textContent=(avail.length&&avail.every(function(c){return c.checked}))?'Clear all':'Select all'}
function update(){
var sel=selected();var n=sel.length;syncAll();
if(!n){countEl.textContent='Select accessories to see your bundle price';priceEl.hidden=true;addBtn.disabled=true;return}
var total=mainPrice();sel.forEach(function(c){total+=parseInt(c.dataset.price,10)||0});
var disc=tierDiscount(n,total);
countEl.textContent=label+' + '+n+(n===1?' Accessory:':' Accessories:');
root.querySelector('.cen-bundle__was').textContent=money(total);
root.querySelector('.cen-bundle__now').textContent=money(total-disc);
root.querySelector('.cen-bundle__save').textContent='Save '+money(disc);
priceEl.hidden=false;addBtn.disabled=false;
}
checks.forEach(function(c){c.addEventListener('change',update)});
root.addEventListener('click',function(e){var slot=e.target.closest('.cen-bundle__slot');if(!slot)return;if(e.target.classList&&e.target.classList.contains('cen-bundle__check'))return;e.preventDefault();e.stopPropagation();var cb=slot.querySelector('.cen-bundle__check');if(cb&&!cb.disabled){cb.checked=!cb.checked;update()}},true);
document.addEventListener('change',function(e){if(e.target&&e.target.name==='id')update()});
if(selAll)selAll.addEventListener('click',function(){var avail=checks.filter(function(c){return !c.disabled});var allOn=avail.length&&avail.every(function(c){return c.checked});avail.forEach(function(c){c.checked=!allOn});update()});
if(addBtn)addBtn.addEventListener('click',function(){
var sel=selected();if(!sel.length)return;
var items=[{id:Number(mainVid()),quantity:1}].concat(sel.map(function(c){return {id:Number(c.dataset.vid),quantity:1}}));
addBtn.disabled=true;addBtn.textContent='Adding\u2026';
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
.then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
.then(function(){window.location.href='/cart'})
.catch(function(){addBtn.textContent='Try again';addBtn.disabled=false});
});
update();
})();